import type { ClientState } from './types'

export const state: ClientState = {
  clients: [],
  client: {} as any,
  currentPage: 1,
}
